// Ekstra ord til Imaginær skrivning — kun korte (2–4 bogstaver), da + en.
// Filtreres mod brugerens låste taster i mentalImageryWordPool().

/** Danske korte ord (almindelige + pensum-nære). */
export const MENTAL_IMAGERY_SUPPLEMENT_DA = [
  'og', 'at', 'er', 'en', 'de', 'et', 'om', 'op', 'nu', 'jo', 'ja', 'vi', 'du',
  'os', 'to', 'tre', 'fire', 'is', 'ny', 'god', 'ond', 'lav', 'arm', 'ben', 'ryg',
  'lad', 'sal', 'dal', 'sad', 'fad', 'mad', 'tag', 'sig', 'det', 'den', 'har',
  'kan', 'man', 'sin', 'din', 'min', 'hun', 'ham', 'mig', 'dig', 'mor', 'far',
  'kat', 'mus', 'hund', 'hus', 'sol', 'bil', 'rose', 'rute', 'lide', 'fare',
  'dele', 'eje', 'ide', 'file', 'fart', 'rist', 'rede', 'læs', 'dæk', 'sæk',
  'alfa', 'saks', 'knas', 'glas', 'skal', 'fald', 'kald', 'flak', 'sang', 'takt',
  'park', 'bord', 'stol', 'hånd', 'varm', 'kold', 'våd', 'tør', 'håb', 'båd',
  'tur', 'leg', 'bog', 'kok', 'top', 'hop', 'kop', 'rop', 'sov', 'gik',
] as const;

/** Engelske korte ord (pensum + almindelige). */
export const MENTAL_IMAGERY_SUPPLEMENT_EN = [
  'he', 'she', 'her', 'the', 'red', 'get', 'ten', 'let', 'rest', 'test',
  'ring', 'fire', 'site', 'rate', 'gate', 'late', 'read', 'head', 'hear',
  'year', 'idea', 'edge', 'ride', 'hide', 'side', 'tile', 'here', 'tree',
  'free', 'feel', 'feed', 'deed', 'seed', 'need', 'heel', 'deer', 'you',
  'our', 'out', 'now', 'how', 'who', 'two', 'too', 'top', 'stop', 'shop',
  'drop', 'word', 'work', 'name', 'same', 'game', 'came', 'home', 'some',
  'come', 'bone', 'tone', 'note', 'vote', 'hope', 'rope', 'type', 'byte',
  'cat', 'can', 'car', 'cap', 'cod', 'cop', 'cow', 'cup', 'cut', 'ace',
  'ice', 'nice', 'once', 'face', 'race', 'box', 'fix', 'mix', 'max', 'tax',
  'fox', 'six', 'wax', 'zoo', 'zone', 'zero', 'zip', 'web', 'job', 'run',
  'sun', 'fun', 'win', 'big', 'hot', 'wet', 'dry', 'old', 'new', 'bad',
  'sad', 'mad', 'lad', 'dad', 'mom', 'son', 'boy', 'man', 'men', 'pen',
  'ink', 'key', 'map', 'bag', 'bed', 'leg', 'ear', 'eye', 'lip', 'jaw',
] as const;

export const MENTAL_IMAGERY_SUPPLEMENT: readonly string[] = [
  ...MENTAL_IMAGERY_SUPPLEMENT_DA,
  ...MENTAL_IMAGERY_SUPPLEMENT_EN,
];
